module.exports = __webpack_public_path__ + "img/part-5-info.b5c56f6c.png";